import React, { useState } from "react";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ListIcon from "../../assets/images/leftsquremenu/list.png";

const menuInfo = [
  { title: "Order History", to: "/order-page" },
  { title: "Change Table", to: "/order-page" },
  { title: "Change Customer", to: "/order-page" },
  { title: "Select Customer", to: "/order-page" },
  { title: "Ticket Note", to: "/order-page" },
  { title: "Cancel All", to: "/order-page" },
  { title: "Guest Number", to: "/order-page" },
  { title: "Open Drawer", to: "/order-page" },
  { title: "Print Bill", to: "/order-page" },
  { title: "Unlock Ticket", to: "/order-page" },
];

const LeftMenuOrderPage = () => {
  const navigate = useNavigate();
  const [selectedIdx, setSelectedIdx] = useState(0);

  const handleMenu = (idx, to) => {
    setSelectedIdx(idx);
    navigate(to);
  };

  return (
    <div>
      {menuInfo.map((item, index) => (
        <MenuBox
          handleMenu={handleMenu}
          info={item}
          key={index}
          idx={index}
          selectedIdx={selectedIdx}
        />
      ))}
    </div>
  );
};

const MenuBox = ({ handleMenu, info, idx, selectedIdx }) => (
  <div
    style={{
      width: 112,
      height: 81,
      background: "#333C4B",
      marginTop: 2,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      borderLeft: `3px solid ${selectedIdx == idx ? "#ED1B24" : "#333C4B"}`,
    }}
    onClick={() => handleMenu(idx, info.to)}
  >
    <Avatar
      sx={{
        width: "26px",
        height: "26px",
      }}
      variant="square"
      src={ListIcon}
    />

    <div
      style={{
        marginTop: 7,
        fontSize: 14,
        color: "#FFFFFF",
        padding: "0 5px",
        fontWeight: "500",
        fontFamily: `Roboto, sans-serif`,
      }}
    >
      {info.title}
    </div>
  </div>
);

export default LeftMenuOrderPage;
